export default __webpack_public_path__ + "static/media/video.217bf5a3.svg";